import * as Factory from 'factory.ts'
import faker from 'faker'

import { type RequestableApproverApiModel } from '@webapp/platform/approval-routing/data-access/api-models/RequestableApproverApiModel'

export const RequestableApproverApiModelStub =
  Factory.Sync.makeFactory<RequestableApproverApiModel>({
    id: Factory.each(() => faker.random.number()),
    group: Factory.each(() => ({
      id: faker.random.number(),
      name: faker.random.word(),
      rank: faker.random.number(),
    })),
    user: Factory.each(() => ({
      id: faker.random.number(),
      email: faker.internet.email(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      profile_image: faker.image.imageUrl(),
    })),
    user_id: Factory.each(() => faker.random.number()),
    threshold: Factory.each(() => faker.random.number().toString()),
    sequence: Factory.each(() => faker.random.number()),
    level_text: Factory.each(() => faker.random.word()),
    vacation_active: false,
  })
